import type { Guide, GuideRecordHint } from '../types';

/**
 * S-26.10-13 — plik od klienta przy prezleceniu (decyzja użytkownika 26.10.2026: z pakietu „skrzynka spraw
 * i podgląd źródeł” teraz tylko wgrywanie pliku do ręcznego prezlecenia; scenariusz e2e 39). A39 — ręczne
 * prezlecenie CS z dołączonym zamówieniem w PDF (`e2e/setup/scenario-state.mjs`). Nagrywarka tylko otwiera
 * podgląd i pole powodu, niczego nie dołącza ani nie usuwa.
 */
const WITH_FILE: GuideRecordHint = {
  description: 'prezlecenie wpisane ręcznie, z dołączonym plikiem od klienta — z listy prezleceń',
  listPath: '/pre-orders',
};

export const guide: Guide = {
  flagKey: 'preOrderAttachments',
  title: 'Plik od klienta przy prezleceniu',
  whatItDoes:
    'Przy prezleceniu wpisanym ręcznie CS albo Administracja dołącza plik, z którego je wpisała: zamówienie w PDF, arkusz, dokument, zdjęcie albo zapisaną wiadomość. Pliki widać na karcie prezlecenia i w oknie kontroli Administracji; PDF i obraz otwierają się na miejscu, resztę pobiera się na dysk. Do akceptacji prezlecenia plik można usunąć — z powodem, który zostaje w historii razem z tym, kto i kiedy dołączył albo usunął plik. Przy ręcznej poprawce pola źródłem ustalenia może być „plik od klienta”.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-26.10-13'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/show',
      record: WITH_FILE,
      target: 'pre-order-attachments',
      title: '„Pliki od klienta” obok źródła',
      description:
        'Na karcie prezlecenia, pod źródłem, sekcja „Pliki od klienta”: nazwa, rodzaj, rozmiar, kto i kiedy dołączył. „Dołącz plik od klienta” przyjmuje PDF, arkusz, dokument, obraz albo zapisaną wiadomość — do 20 MB.',
      action: 'Kliknij „Dołącz plik od klienta” i wybierz plik z dysku.',
      recorder: { account: 'cs', demo: { kind: 'scenario', key: 'a39PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: WITH_FILE,
      target: 'pre-order-attachment-viewer',
      title: 'Podgląd PDF i obrazu na miejscu',
      description:
        '„Podgląd” otwiera PDF albo zdjęcie bezpośrednio na karcie, obok danych prezlecenia. Arkusz, dokument i wiadomość pobiera się przyciskiem „Pobierz”.',
      action: 'Kliknij „Podgląd” przy pliku PDF.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a39PreOrderId' },
        actions: [{ kind: 'click', target: 'pre-order-attachment-preview' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/show',
      record: WITH_FILE,
      target: 'pre-order-attachment-delete-reason',
      title: 'Usunięcie przed akceptacją — z powodem',
      description:
        'Pomyłkowo dołączony plik usuwa się przed akceptacją prezlecenia, podając powód (co najmniej 10 znaków). Plik znika, a w historii prezlecenia zostaje wpis: jaki plik, kto, kiedy i dlaczego. Po akceptacji plik zostaje.',
      action: 'Kliknij „Usuń” przy pliku, wpisz powód i „Usuń plik”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'scenario', key: 'a39PreOrderId' },
        actions: [{ kind: 'click', target: 'pre-order-attachment-delete' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: WITH_FILE,
      target: 'pre-order-attachments',
      title: 'Te same pliki w oknie kontroli',
      description:
        'Administracja widzi pliki od klienta w oknie kontroli, obok stanu zapisu i plików dla TMS — sprawdza dane prezlecenia z dokumentem klienta, bez przechodzenia na kartę.',
      action: 'Otwórz okno kontroli prezlecenia.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'a39PreOrderId' } },
    },
  ],
};
